import styled from '@emotion/styled';

export const FixFrontDeskWrapper = styled('div', {
  label: 'fix-front-desk-wrapper',
})`
  position: relative;
  height: 100%;
`;
